import { FC, useMemo } from 'react'
import { ProducerMapCardProps as Props } from 'components/producers/producer-map-card/types'
import ProducerLocation from 'components/producers/producer-location/ProducerLocation'
import styles from './ProducerMapCard.module.scss'
import { CapacityState } from 'types/producer'
import { getCapacityState, getProducerLocation } from 'utils/producers'
import { useTranslation } from 'next-i18next/pages'
import ProducerCta from 'components/producers/producer-cta/ProducerCta'
import { isReserved as getIsReserved } from 'utils/producers'
import { useStoreSelector } from 'hooks/store'
import useSelectInputGroup from 'hooks/useSelectInputGroup'
import { InputGroupKeys } from 'store/customer/enums'
import { ProgressIndicator } from '@boltenergy-be/design-system'
import { useGetLanguage } from 'hooks/useGetLanguage'

const ProducerMapCard: FC<Props> = ({ location }) => {
  // REDUX STORE
  const { didSimulation } = useStoreSelector((store) => store.customer.flows.simulation)
  const simulation = useSelectInputGroup(InputGroupKeys.SIMULATION)

  // i18n
  const { t } = useTranslation('producer')
  const language = useGetLanguage()

  // Contants
  const capacityState = useMemo<CapacityState>(
    () => getCapacityState(location, simulation, didSimulation),
    [location, simulation, didSimulation]
  )
  const isReserved = useMemo<boolean>(() => getIsReserved(location), [location])

  return (
    <div className={styles.card}>
      <strong className="h4 serif">{location.name[language]}</strong>
      <div className={styles['producer-location-container']}>
        <ProducerLocation
          energyType={location.energyType}
          location={getProducerLocation(language, location?.location)}
          className={styles.location}
        />
      </div>
      <p className={styles.percentage}>
        {t('alreadyOrdered', 'Reeds besteld')}: {capacityState.usedEnergy}%
      </p>
      <ProgressIndicator id={`progress-${location.name[language]}`} className="mb-400" progress={capacityState.usedEnergy} />
      <ProducerCta isProducerDetail producerSlug={location.slug} {...{ capacityState, isReserved }} />
    </div>
  )
}

export default ProducerMapCard
